import { StyledHeaderTitle } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/StyledComponents";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { i18nFilter } from "app/filters/i18nFilter";

export const Title = () => {
    const i18n = i18nFilter();
    return (
        <StyledHeaderTitle>
            <BoxTitle tooltip={i18n("wa.wwo.social.title.tooltip")}>{i18n("analysis.social.title")}</BoxTitle>
        </StyledHeaderTitle>
    );
};
